module.exports = __webpack_public_path__ + "Roboto-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.ttf
// module id = 88
// module chunks = 0